import PricingTableComponent from './PricingTable';

export default PricingTableComponent;
